"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,1.99079514 L2,1.99079514 L2,18.0092049 C2,17.9974966 2.00251521,18 2.00494659,18 L21.9950534,18 C22.0012546,18 22,18.001246 22,18.0092049 L22,1.99079514 C22,2.00250344 21.9974848,2 21.9950534,2 L2.00494659,2 C1.9987454,2 2,1.99875399 2,1.99079514 L2,1.99079514 Z M0,1.99079514 C0,0.891309342 0.897026226,0 2.00494659,0 L21.9950534,0 C23.1023548,0 24,0.898212381 24,1.99079514 L24,18.0092049 C24,19.1086907 23.1029738,20 21.9950534,20 L2.00494659,20 C0.897645164,20 0,19.1017876 0,18.0092049 L0,1.99079514 L0,1.99079514 Z"
  })));
};

exports["default"] = _default;